/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_ContinueInputs */

const cs_ebr_continue = /** @type {(inputs: Ebr_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokračovat`)
};

const en_ebr_continue = /** @type {(inputs: Ebr_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue`)
};

/**
* | output |
* | --- |
* | "Continue" |
*
* @param {Ebr_ContinueInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_continue = /** @type {((inputs?: Ebr_ContinueInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_ContinueInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_continue(inputs)
	return cs_ebr_continue(inputs)
});